export const COMPANY_STATS = {
  founded: 2000,
  get yearsExperience() {
    return new Date().getFullYear() - this.founded;
  },
  clients: "2,186+",
  projects: "2,899+",
  transactions: "3,112+",
  containers: "1,000+",
  countries: "70+"
};
